import moment from 'moment';
import { logger } from '../shared/utils/helpers/logger';

export const renderTime = (date) => {
    let dateTime = moment(Date(date));
    let hour = dateTime.hour();
    let minutes = dateTime.minute();
    return hour + ":" + minutes;
};

export const randomNumber = (length) => {
    let otp = '';
    for (let i = 0; i < length; i++) {
        otp += Math.floor(Math.random() * 10).toString();
    }
    return otp;
}

/// Development File
// export let url = 'http://localhost:1717/v1'; //
// export let url = 'https://mapi.dev.miira.ca/v1';// testing server
export let url = 'https://api.miirapos.com/v1';
// export const url_in = 'https://api.in.miirapos.com/v1';

export let region = 'Canada';

/**
 * API Configuration by Region
 * 
 * ✅ SECURITY: All URLs use HTTPS in production
 * ⚠️ HTTP only allowed for localhost development
 */
export const API_BY_COUNTRY = {
    // ✅ SECURITY: localhost HTTP allowed for development only
    // developer: "http://localhost:1717/v1",
    // Alternative dev server (if needed)
    // developer: "https://mapi.dev.miira.ca/v1",
    
    // ✅ Production APIs use HTTPS
    Canada: "https://api.miirapos.com/v1",
    India: "https://api.in.miirapos.com/v1",
};

// /**
//  * ✅ SECURITY: Validate HTTPS in production
//  * Throws error if non-HTTPS URL is used in production
//  */
// if (process.env.NODE_ENV === 'production') {
//     Object.entries(API_BY_COUNTRY).forEach(([region, apiUrl]) => {
//         if (!apiUrl.startsWith('https://')) {
//             console.error(`🔒 SECURITY ERROR: Insecure API URL for ${region}: ${apiUrl}`);
//             throw new Error(`SECURITY: Production must use HTTPS. Found HTTP URL for ${region}`);
//         }
//     });
// }

export const getApiUrl = () => {
    const storedUrl = window.localStorage.getItem('api_base_url');
    console.log(storedUrl);
    // // ✅ SECURITY: Validate stored URL in production
    // if (process.env.NODE_ENV === 'production' && storedUrl && !storedUrl.startsWith('https://')) {
    //     console.error('🔒 SECURITY: Removing insecure API URL from localStorage');
    //     window.localStorage.removeItem('api_base_url');
    //     return API_BY_COUNTRY.Canada; // Fallback to secure default
    // }
    
    return storedUrl || API_BY_COUNTRY.Canada;
};

export function getRegion(){
    return window.localStorage.getItem('api_region') || "developer";
}

export const SITE_KEY = '6LfAJIsrAAAAAMYx3GqDOPPYzZsGKasAj_xPkQwU'; // New Site Key By Yash....



export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function countOrdersByType(orders) {
    const orderTypeInStore = "in-store";
    const orderTypePickup = "pickup";
    const orderTypeKiosk = "Kiosk";
    const orderTypeOnline = "online";
    const orderTypePartners = "patners";


    const counts = {
        [orderTypeInStore]: 0,
        [orderTypePickup]: 0,
        [orderTypeKiosk]: 0,
        [orderTypeOnline]: 0,
        [orderTypePartners]: 0
    };

    orders.forEach(order => {
        switch (order.type) {
            case 0: // Assuming 0 represents 'in-store'
                counts[orderTypeInStore] = (counts[orderTypeInStore] || 0) + 1;
                break;
            case 1: // Assuming 1 represents 'pickup'
                counts[orderTypePickup] = (counts[orderTypePickup] || 0) + 1;
                break;
            case 2: // Assuming 2 represents 'Kiosk'
                counts[orderTypeKiosk] = (counts[orderTypeKiosk] || 0) + 1;
                break;
            case 3: // Assuming 3 represents 'online'
                counts[orderTypeOnline] = (counts[orderTypeOnline] || 0) + 1;
                break;
            default:
                logger.warn(`Counting rest partner order type: ${order.type}`);
                counts[orderTypePartners] = (counts[orderTypePartners] || 0) + 1;

        }
    });

    return counts;
}

export async function fetchTimeandDateRange(filterType) {
    let start, end;
    const now = new Date();

    // Helper to get the start of a day in UTC
    const getStartOfDayUTC = (date) => {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
    };
    
    // Helper to get the end of a day in UTC
    const getEndOfDayUTC = (date) => {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));
    };

    switch (filterType) {
        case "today":
            start = getStartOfDayUTC(now);
            end = getEndOfDayUTC(now);
            break;

        case "yesterday":
            const yesterday = new Date(now.getTime() - 86400000); // Subtract 24 hours
            start = getStartOfDayUTC(yesterday);
            end = getEndOfDayUTC(yesterday);
            break;

        case "weekly":
            const currentDay = now.getUTCDay(); // Sunday = 0, Saturday = 6
            const firstDayOfWeek = new Date(now.getTime() - currentDay * 86400000);
            start = getStartOfDayUTC(firstDayOfWeek);
            
            const lastDayOfWeek = new Date(firstDayOfWeek.getTime() + 6 * 86400000);
            end = getEndOfDayUTC(lastDayOfWeek);
            break;
            
        // FIX 1: Corrected spelling and logic
        case "bi-weekly": 
            const dayOfWeek = now.getUTCDay();
            const startOfThisWeek = new Date(now.getTime() - dayOfWeek * 86400000);
            
            // The start is the beginning of the previous week (7 days before the start of this week)
            const startOfBiWeeklyPeriod = new Date(startOfThisWeek.getTime() - 7 * 86400000);
            start = getStartOfDayUTC(startOfBiWeeklyPeriod);

            // The end is the end of the current week
            const endOfThisWeek = new Date(startOfThisWeek.getTime() + 6 * 86400000);
            end = getEndOfDayUTC(endOfThisWeek);
            break;

        // FIX 2: Corrected case name and switched to UTC calculations
        case "last30Days": 
        logger.log('Returning data for last 30days...');
            const endOf30DayPeriod = new Date(now);
            end = getEndOfDayUTC(endOf30DayPeriod);
            
            // Subtract 29 days because we are including today as the first day
            const startOf30DayPeriod = new Date(now.getTime() - 30 * 86400000);
            start = getStartOfDayUTC(startOf30DayPeriod);
            break;

        default:
            // For custom ranges, you can pass an object
            if (typeof filterType === 'object' && filterType.start && filterType.end) {
                start = new Date(filterType.start);
                end = new Date(filterType.end);
            } else {
                throw new Error(`Invalid filter type: ${filterType}`);
            }
    }

    logger.log(`Fetching data from ${start.toISOString()} to ${end.toISOString()}`);
    return { start, end };
}





